import React from 'react';
import * as yup from 'yup';
import FormSection from '../../../../../common/membershipFormComponents/FormSection';

const fields = [
  {
    colSpan: 1,
    name: 'texFabricWovenExpoCap',
    type: 'text',
    label: 'Woven (mtr)',
  },
  {
    colSpan: 1,
    name: 'texFabricKnitExpoCap',
    type: 'text',
    label: 'Knit (kg)',
  },
];

export const textileFabricExpoCapFieldsValidation = {
  [fields[0].name]: yup.string().label(fields[0].label),
  [fields[1].name]: yup.string().label(fields[1].label),
};

const TextileFabricExpoCap = (props) => {
  return (
    <FormSection
      sectionName="Fabric Exportable Capacity"
      sectionColumn={2}
      formFields={fields}
      {...props}
    />
  );
};

export default TextileFabricExpoCap;
